export default [
  {
    path: 'index/:title/:subId/:classId/:taskId/:limitTime',
    component (resolve) {
      require(['@/page/student/test/countdownTest'], resolve)
    },
    meta: {
    }
  },
  {
    path: 'test-card/:subId/:classId',
    component (resolve) {
      require(['@/page/student/test/test-card'], resolve)
    },
    meta: {
    }
  },
  {
    path: 'test-answer-list/:subId/:classId',
    component (resolve) {
      require(['@/page/student/test/answer/testAnswerList'], resolve)
    },
    meta: {
      title: '测验'
    }
  }
]



// WEBPACK FOOTER //
// ./src/router/student/test.js